import { forwardRef } from "react";
import { Link } from "react-router-dom";
import krewLogo from "@/assets/krew-logo.png";

const Footer = forwardRef<HTMLElement>((_, ref) => {
  return (
    <footer ref={ref} className="border-t border-border bg-background px-6 py-12">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-6 md:flex-row">
        <a href="#" className="flex items-center gap-2">
          <img src={krewLogo} alt="Krew" className="h-8 w-8" />
          <span className="text-xl font-bold text-gradient-logo">Krew</span>
        </a>
        <div className="flex flex-wrap justify-center gap-6 md:gap-8">
          {[
            { label: "How It Works", href: "#how-it-works" },
            { label: "Features", href: "#features" },
            { label: "For Venues", href: "#venues" },
            { label: "Pricing", href: "#pricing" },
          ].map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="text-sm text-muted-foreground transition-colors hover:text-foreground"
            >
              {link.label}
            </a>
          ))}
          <Link
            to="/auth?redirect=/vendor&role=vendor"
            className="text-sm text-secondary transition-colors hover:text-foreground font-medium"
          >
            Partner With Us
          </Link>
        </div>
        <div className="flex flex-col items-center gap-2 md:items-end">
          <p className="text-xs text-muted-foreground">
            © 2026 Krew. All rights reserved.
          </p>
          <a
            href="https://bwestudios.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs font-medium text-muted-foreground transition-colors hover:text-foreground"
          >
            Built by <span className="font-semibold tracking-wide text-gradient-neon">BWE Studio</span>
          </a>
        </div>
      </div>
    </footer>
  );
});

Footer.displayName = "Footer";

export default Footer;
